<div class="loader-div" id="loader" *ngIf="!isReady || (isReady && !isLoggedIn)">
    <i class="fa fa-spinner fa-pulse fa-3x fa-fw loader-image"></i>
</div>
<router-outlet *ngIf="isReady && isLoggedIn"></router-outlet>
<ng-template #logOutSession let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Confirmation</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p>
            Your session expiring soon, Do you want to continue this session ?
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="continue()">Continue</button>
        <button type="button" class="btn btn-secondary" (click)="logout()">Logout</button>
    </div>
</ng-template>

<ng-template #rolePermissions let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Oops!</h4>
    </div>
    <div class="modal-body">
        <p>
            {{rolesError}}
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="logout();d('Cross click');">Ok</button>
    </div>
</ng-template>